import { useState } from "react";
import { EmailInput, PasswordInput } from "../components/forms/Inputs";
import { Form } from "../components/forms/Form";
import { useApi } from "../hooks/useApi";
import { useStorage } from "../layers/Storage";
import { FaArrowRight } from "react-icons/fa";
import { useTranslations } from "../layers/Localization";
import { BadRequest } from "../layers/ErrorBoundary";

export function Signin() {
    const [email, setEmail] = useState("")
    const [password, setPassword] = useState("")
    const [error, setError] = useState("")

    const api = useApi()
    const [, , set] = useStorage()
    const t = useTranslations()

    const submit = async () => {
        try {
            const token = await api.post('/signin?cookie=true', { email, password })
            set('token')(token)
        } catch (err) {
            if (err instanceof BadRequest) {
                setError(t('Email ou mot de passe incorrect'))
            } else {
                throw err
            }
        }
    }

    return <Form onSubmit={submit} className="w-full">
        <h1 className="text-center text-xl font-bold mb-5">{t('Connexion')}</h1>
        <EmailInput value={email} onChange={setEmail} required className="grow" />
        <PasswordInput value={password} onChange={setPassword} required className="mt-2" />
        {error && <div className="mt-2 text-red-600">{error}</div>}
        <div className="mt-5 flex justify-center">
            <button className="flex items-center gap-2">
                <div>{t('Connexion')}</div>
                <FaArrowRight />
            </button>
        </div>
    </Form>
}